function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hand-made_svg__cls-1{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:inherit}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "hand-made_svg__cls-1",
  d: "M1.925 4.121c.237-.067 1.296-.374 2.13-.239.445.072.78.251.915.382.06.058.1.109.209.233.119.136.152.17.163.183.18.199.347.368.377.398.07.068.244.212 1.5.425.348.059.559.086.728.266.037.04.219.234.167.459-.035.154-.165.236-.187.256-.079.068-.18.079-.594.022-.57-.08-1.006-.189-1.248-.242a7.74 7.74 0 00-1.03-.154"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "hand-made_svg__cls-1",
  d: "M8.035 6.4a30.868 30.868 0 002.764-1.28c.192-.185.492-.17.649.004a.453.453 0 01.012.567 32.005 32.005 0 01-2.741 2.03c-.88.115-1.76.23-2.641.343a14.649 14.649 0 01-2.387-.703c-.632-.247-1.228-.494-1.715-.76"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "hand-made_svg__cls-1",
  d: "M.147 8.186c.967-.107 1.493-.311 1.607-.398a.611.611 0 00.147-.161.53.53 0 00.078-.285c.008-.208-.011-1.537-.057-3.36a.571.571 0 00-.2-.343.57.57 0 00-.357-.125l-1.218.05m10.709 1.494a.392.392 0 00-.115-.211c-.132-.12-.353-.132-.551-.025l-2.243.947m2.093-.924a.41.41 0 00-.084-.279c-.113-.137-.328-.181-.53-.099L7.22 5.503"
});

function SvgHandMade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-made_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgHandMade;